var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Toolbar',{attrs:{"toolbarTitle":_vm.$t('Archiv Aktualisieren'),"showDrawer":false,"lastPath":-1,"tooltipMessage":_vm.$t('Hier können Sie Archiv hinzufügen. Auch können Sie hier Ihre Aufgaben archivieren.')}}),_c('ArchiveAdd',{attrs:{"value":_vm.getSelectedTaskArchive.data,"type":"UPDATE"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }